import UICalendar from "@/components/calendar";
import CircularLoader from "@/components/circular-loader";
import { Enums } from "@/services/dropdown-enums";
import {
  getCurrentTimezone,
} from "@/services/generic.methods";
import { getTimezones } from "@/store/slices/general/generalSlice";
import { Box } from "@mui/material";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useSelector , useDispatch } from "react-redux";

import { toast } from "react-toastify";

export default function CalendarSection(props) {
  const {
    eventActions,
    appointments,
    onSlotClick,
    handleOnEventDrop = () => {},
    loading = false,
    selectedView = "month",
    handleView = (view) => {},
    handleRange = (range) => {},
    timeZone,
    views = undefined,
    customEventTile = undefined,
    eventStyling = undefined,
    className = "",
    ...rest
  } = props;
  const dispatch = useDispatch();
  const timezones = useSelector(getTimezones);

  const [calendarAppointments, setCalendarAppointments] = useState([]);

  const onEventDrop = useCallback(
    ({
      event,
      start,
      end,
      isAllDay: droppedOnAllDaySlot = false,
      resourceId,
    }) => {
      if (rest?.resourceIdAccessor)
        if (event?.resourceId !== resourceId) {
          toast.warn(
            `Appointment can not be moved to another Apointment Type.`
          );
          return; // Do not update state
        }

      const { allDay } = event;
      if (!allDay && droppedOnAllDaySlot) {
        event.allDay = true;
      }

      console.log("onDrag event", event, allDay);
      console.log("droppedOnAllDaySlot", droppedOnAllDaySlot);
      const existing = appointments.find((ev) => ev.id === event.id) ?? {};
      const filtered = appointments.filter((ev) => ev.id !== event.id);
      let newAppointments = [...filtered, { ...existing, start, end, allDay }];
      // dispatch(setAppointmentsToState(newAppointments));
      handleOnEventDrop({ ...existing, start, end, allDay });
    },
    [appointments]
  );

  // const getCurrentTimezone = () => {
  //   const offset = moment().utcOffset();
  //   const hours = Math.floor(Math.abs(offset) / 60);
  //   const minutes = Math.abs(offset) % 60;
  //   const sign = offset >= 0 ? '+' : '-';
  //   const formattedOffset = `(UTC${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')})`;
  //   const currentTz = timezones.find(tz => tz.label.startsWith(formattedOffset));
  //   return currentTz?.value
  // }

  const handleDate = (date) => {
    try {
      const stripped = String(date || "")
        .replace(/\.\d{3}Z$/i, "")
        .replace(/Z$/i, "");
      const wallClock = moment.utc(stripped);
      return wallClock.isValid() ? wallClock : moment(date);
    } catch (error) {
      return moment(date);
    }
  };

  useEffect(() => {
    const mappedAppointments = appointments
      ?.filter((ev) => {
        const status = String(ev.status ?? "").toLowerCase();
        const isCanceled =
          ev.status === Enums.AppointmentStates.Canceled ||
          ev.status === Enums.AppointmentStatuses.Canceled ||
          status === "canceled" ||
          status === "cancelled" ||
          status === "4" ||
          status === "5";
        return !isCanceled;
      })
      ?.map((ev) => {
        let startMoment = handleDate(ev.startDate);
        let endMoment = handleDate(ev.endDate);

        // React Big Calendar Month View sorts events primarily by start time.
        // For busy slots (which start early/throughout the day), they dominate and crowd out booked events.
        // Faking the start/end time to the very end of the day (23:59:59) only in month view
        // pushes busy slots to the bottom of the cell (meaning they go into the "+X more" popper),
        // prioritizing regular booked events. Details popup still uses original ev.startDate.
        if (selectedView === "month" && ev.isBusy) {
          startMoment = startMoment
            .clone()
            .hour(23)
            .minute(59)
            .second(59)
            .millisecond(0);
          endMoment = endMoment
            .clone()
            .hour(23)
            .minute(59)
            .second(59)
            .millisecond(0);
        }

        return {
          ...ev,
          start: new Date(startMoment.format("MM/DD/YYYY HH:mm:ss")),
          end: new Date(endMoment.format("MM/DD/YYYY HH:mm:ss")),
          selectedTimeZone: timeZone || getCurrentTimezone(timezones),
        };
      });
    setCalendarAppointments(mappedAppointments || []);
  }, [appointments, timeZone, timezones, selectedView]);

  return (
    <main>
      <Box className={className} sx={{ position: "relative" }}>
        {loading && (
          <Box
            sx={{
              position: "absolute",
              zIndex: 99,
              width: "100%",
              height: "100%",
              left: 0,
              top: 0,
              background: "rgba(255,255,255,0.6)",
            }}
          >
            <CircularLoader />
          </Box>
        )}
        <UICalendar
          events={calendarAppointments}
          selectedView={selectedView}
          handleView={handleView}
          options={{
            contextMenuOptions: eventActions,
            onEventDrop,
            onSlotClick,
          }}
          stopDraggable={false}
          handleRange={handleRange}
          views={views}
          customEventTile={customEventTile}
          eventStyling={eventStyling}
          showAvatar={true}
          showMultiDayTimes={true}
          {...rest}
        />
      </Box>
    </main>
  );
}
